module.exports = __webpack_public_path__ + "static/BL002-11430d4726ae13115a0d0a659c523e78.svg";